/**
 * Marker sent by Multipass instead of a trade id when the back office (Xone) has not integrated
 * the deal yet. It is relayed verbatim by multipass-bridge, and a real trade id may come later,
 * either through a corrective fill report or through a blotter live notification.
 */
export const NOT_YET_INTEGRATED_TRADE_ID = 'NOT_YET_INTEGRATED';

export const isNotYetIntegrated = (tradeIds: string[]): boolean => tradeIds[0] === NOT_YET_INTEGRATED_TRADE_ID;
